/**
 * @typedef {import('./BaseInputProps').default} Props
 * @typedef {import('formik').FormikProps<import('formik').FormikValues>} Formik
 * @typedef {{
 * 	field: {
 * 		name: string;
 * 		onBlur: (event: import('react').FocusEvent<HTMLTextAreaElement>) => void;
 * 		onChange: (event: import('react').ChangeEvent<HTMLTextAreaElement>) => void;
 * 		value?: string | null;
 * 	};
 * 	form: Formik;
 * }} RenderProps
 */

import { Field } from 'formik';
import React from 'react';

/** @extends {React.Component<Props>} */
export default class InputTextarea extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		this.renderTextarea = this.renderTextarea.bind(this);
	}

	/**
	 * @param {RenderProps} renderProps
	 * @returns {JSX.Element}
	 */
	renderTextarea(renderProps) {
		const onBlur = this.props.onBlur;
		const onChange = this.props.onChange;

		return (
			<textarea
				autoComplete={this.props.autocomplete}
				className={`${this.props.className} input`.trim()}
				defaultValue={renderProps.field.value ?? undefined}
				disabled={this.props.disabled}
				id={this.props.id ?? this.props.name}
				maxLength={this.props.maxLength}
				name={renderProps.field.name}
				onBlur={
					onBlur
						? (event) => onBlur(event, renderProps.form)
						: renderProps.field.onBlur
				}
				onChange={
					onChange
						? (event) => onChange(event, renderProps.form)
						: renderProps.field.onChange
				}
				placeholder={this.props.placeholder}
				required={this.props.required}
			/>
		);
	}

	render() {
		return <Field name={this.props.name}>{this.renderTextarea}</Field>;
	}
}

InputTextarea.defaultProps = {
	className: '',
	disabled: false,
	required: false,
};
